import { Box, Text } from '@chakra-ui/react';
import React from 'react';

interface ContractDataBoxProps {
  label: string;
  children: React.ReactNode;
  loading?: boolean;
}

const ContractDataBox = ({
  children,
  label,
  loading,
}: ContractDataBoxProps) => {
  return (
    <Box w="64">
      <Text
        w={loading ? '60px' : ''}
        h={loading ? '19.25px' : ''}
        bg={loading ? 'yGray.50' : ''}
        borderRadius={loading ? '5px' : ''}
        color={loading ? 'transparent' : ''}
        variant="regular"
        mb="2"
      >
        {label}
      </Text>
      <Text
        w={loading ? '80px' : ''}
        h={loading ? '19.25px' : ''}
        bg={loading ? 'yGray.50' : ''}
        borderRadius={loading ? '5px' : ''}
        color={loading ? 'transparent' : ''}
      >
        {children}
      </Text>
    </Box>
  );
};
export default ContractDataBox;
